/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Meeting_Attendees_TitleInputs */



/**
* | output |
* | --- |
* | "Participants ({count})" |
*
* @param {Meeting_Attendees_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_attendees_title = /** @type {((inputs: Meeting_Attendees_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Attendees_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Deelnemers (${i?.count})`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Participants (${i?.count})`)
	return /** @type {LocalizedString} */ (`Participants (${i?.count})`)
});